var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDecline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m4.24 4.063-7.177 7.178a5.158 5.158 0 0 0 7.178-7.178M7 1.843a5.158 5.158 0 0 0-4.24 8.094l7.177-7.178A5.13 5.13 0 0 0 7 1.842"
})));
export default SvgDecline;